import FormattedMessage from 'I18n/components/FormattedMessage';
import CurrentPlanButton from 'pricing-pages-lib/js/buttons/CurrentPlanButton';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { getButtonVariantProps, getTrellisButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import SignupButton from 'pricing-pages-ui/components/common/SignupButton';
import SkeletonLoadWrapper from 'pricing-pages-ui/components/common/loading/SkeletonLoadWrapper';
import { HighlightedProductsHeaderConfig } from 'pricing-pages-ui/constants/merchCards/HighlightedProductsHeaderConfig';
import { useSelector } from 'react-redux';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppSelector } from '../../../reducers';
import { isUngatedForInbound25Selector, isUngatedForSeatsSelector } from '../../../selectors/GatingSelectors';
import { ownsCrmSuiteProductLevel } from '../../../selectors/ProductInventorySelectors';
import { useFTS0017orFTS0018ExperimentEffect } from '../../../utils/experiments/fts0017_fts0018';
import { MerchCardLayoutUI } from '../../../v2/components/MerchCardLayoutUI';
import { MerchCardSubheadingContainer } from '../../../v2/containers/merch-card/headings-display/MerchCardSubheadingContainer';
import { MerchCardTitleContainer } from '../../../v2/containers/merch-card/headings-display/MerchCardTitleContainer';
import { FreeCardBadge } from '../../common/badges/FreeCardBadge';
import { SuiteFeatures } from '../features-display/SuiteFeatures';
import FreePriceDisplayStyled from '../price-display/FreePriceDisplayStyled';
import { jsx as _jsx } from "react/jsx-runtime";
export const FreeCard = ({
  productLine,
  columnStart,
  trackingSource
}) => {
  var _HighlightedProductsH;
  const isAppReady = useGlobalLoading();
  const isSeatsRedesignUngated = useSelector(isUngatedForSeatsSelector);
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const isMobile = useIsMobile();
  const isCurrentPlanLevel = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel: FREE
  }));
  const {
    loading: isLoadingFTS0017AndFTS0018Experiment,
    variant: isInFTS0017AndFTS0018ExperimentVariant
  } = useFTS0017orFTS0018ExperimentEffect();
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  const trellisCtaVariantProps = getTrellisButtonVariantProps({
    variant: 'block'
  });
  const titleMessage = isInFTS0017AndFTS0018ExperimentVariant && !isLoadingFTS0017AndFTS0018Experiment ? 'merchCards.freeCard.productLevelTitle' : 'merchCards.freeCard.title';
  const Title = /*#__PURE__*/_jsx(MerchCardTitleContainer, {
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleMessage
    }),
    Badge: /*#__PURE__*/_jsx(FreeCardBadge, {})
  });
  const SubHeading = /*#__PURE__*/_jsx(MerchCardSubheadingContainer, {
    Subheading: productLine === 'crm' ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.freeCard.description.crm"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: ((_HighlightedProductsH = HighlightedProductsHeaderConfig[productLine][FREE]) === null || _HighlightedProductsH === void 0 ? void 0 : _HighlightedProductsH.subtitle) || ''
    })
  });
  const Seats = isMobile ? null : isSeatsRedesignUngated ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "merchCards.subtexts.free.current"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "merchCards.subtexts.free.legacy"
  });
  const CTAs = /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !isAppReady,
    heights: [47],
    widths: ['100%'],
    children: isCurrentPlanLevel ? /*#__PURE__*/_jsx(CurrentPlanButton, {
      visible: trellisCtaVariantProps.visible
    }) : /*#__PURE__*/_jsx(SignupButton, Object.assign({
      sourceId: "pricing-hero",
      productLine: "crm",
      use: "primary",
      trackingSource: trackingSource
    }, ctaVariantProps))
  });
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-test-id": `${productLine}-free-card`,
    "data-selenium-id": `${productLine}-free-card`,
    columnStart: columnStart,
    Title: Title,
    Subheading: SubHeading,
    Pricing: /*#__PURE__*/_jsx(FreePriceDisplayStyled, {}),
    Seats: Seats,
    CTAs: CTAs,
    Features: /*#__PURE__*/_jsx(SuiteFeatures, {
      productLevel: FREE,
      loading: !isAppReady,
      isCollapsible: isMobile
    }),
    isUngatedForInbound25: isUngatedForInbound25
  });
};